import actions from './store/actions';

const store = {
  namespaced: true,

  actions,
};

export default store;
